



































































































import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator'
import HdsTextField from '@/components/HdsTextField.vue'
import HdsDropdown from '@/components/HdsDropdown.vue'
import { ClickOutside } from '@/directives'
import HdsIcon from '@/components/HdsIcon.vue'

/**
 * 가장 많이 쓰임. 자동완성, 신규등록 기능도 포함해야함.
 */
@Component({
  components: { HdsIcon, HdsTextField, HdsDropdown },
  directives: { ClickOutside },
})
export default class HdsSelect extends Vue {
  value: string = ''
  on: boolean = false

  selectedItemHighlightedIndex: null | number = null
  itemHighlightedIndex: null | number = null

  @Watch('on')
  onChangedOn(cur: boolean) {
    if (!cur) {
      this.itemHighlightedIndex = null
      this.selectedItemHighlightedIndex = null
    }
  }

  @PropSync('items', { default: () => [] }) itemsSync!: any[]
  @PropSync('selectedItems', { default: () => [] }) selectedItemsSync!: any[]

  created() {
    if (this.itemObject)
      this.selectedItemsSync = this.selectedItemsSync.map(e =>
        this.itemsIncludes(e)
          ? this.itemsSync.find(i => i[this.itemValue] === e[this.itemValue])
          : e,
      )

    this.initParsedItemsSync()
    this.initParsedSelectedItemsSync()
  }

  get itemsIncludes() {
    return (item: any) =>
      this.itemsSync.some(e => e[this.itemValue] === item[this.itemValue])
  }

  get selectedItemsIncludes() {
    return (item: object & any) => {
      return this.parsedSelectedItemsSync.some(
        e => e[this.itemValue] === item[this.itemValue],
      )
    }
  }

  parsedItemsSync: any[] = []
  initParsedItemsSync() {
    this.parsedItemsSync = this.itemsSync.reduce((acc: any, item: any) => {
      if (this.itemObject) acc.push(item)
      else
        acc.push({
          [this.itemText]: item.trim(),
          [this.itemValue]: item.trim(),
        })
      return acc
    }, [])
  }
  @Watch('parsedItemsSync')
  onWatchParsedItemsSync(cur: any[]) {
    if (this.itemObject) this.itemsSync = cur
    else this.itemsSync = cur.map((item: any) => item[this.itemText])
  }

  parsedSelectedItemsSync: any[] = []
  initParsedSelectedItemsSync() {
    this.parsedSelectedItemsSync = this.selectedItemsSync.reduce(
      (acc: any, item: any) => {
        const found = this.parsedItemsSync.find((origin: any) =>
          this.itemObject
            ? origin[this.itemValue] === item[this.itemValue]
            : origin[this.itemText] === item,
        )
        if (found) acc.push(found)
        else
          console.error(
            `목록에 선택 아이템 ${JSON.stringify(item)} 존재하지 않습니다.`,
          )

        return acc
      },
      [],
    )
  }
  @Watch('parsedSelectedItemsSync')
  onWatchParsedSelectedItemsSync(cur: any[]) {
    if (this.itemObject) this.selectedItemsSync = cur
    else this.selectedItemsSync = cur.map((item: any) => item[this.itemText])
  }

  get filteredItemsSync() {
    return this.parsedItemsSync.filter((item: any) => {
     const hasValue = item[this.itemText]
            .toLowerCase()
            .includes(this.value.toLowerCase())
      return this.hideSelected ? hasValue && !this.selectedItemsIncludes(item) : hasValue
    })
  }
  set filteredItemsSync(items: any[]) {
    this.parsedItemsSync = items
  }

  get computedPlaceholder() {
    return (this.multiple || this.selectedItemsSync.length === 0) ? this.placeholder : ''
  }

  toggle(item: any) {
    if (this.multiple) this.toggleMultiple(item)
    else this.selectSingle(item)
  }

  selectSingle(item: any) {
    this.parsedSelectedItemsSync = [item]
  }

  toggleMultiple(item: any) {
    const found = this.parsedSelectedItemsSync.find(
      e => e[this.itemValue] === item[this.itemValue],
    )

    if (!found) this.selectMultiple(item)
    else this.unselectMultiple(found)
  }

  selectMultiple(item: any) {
    this.parsedSelectedItemsSync = [...this.parsedSelectedItemsSync, item]
  }

  unselectMultiple(item: any) {
    this.parsedSelectedItemsSync = this.parsedSelectedItemsSync.filter(
      cur => cur[this.itemValue] !== item[this.itemValue],
    )
  }

  focusTextField() {
    if (!(this.$refs.textField as HdsTextField).$refs.input) return
    ;((this.$refs.textField as HdsTextField).$refs
      .input as HTMLInputElement).focus()
  }

  blurTextField() {
    if (!(this.$refs.textField as HdsTextField).$refs.input) return
    ;((this.$refs.textField as HdsTextField).$refs
      .input as HTMLInputElement).blur()
  }

  onInput(value: string) {
    this.$emit('input', value)
  }

  onClickTextField(forceToggleDropdown: any) {
    forceToggleDropdown(true)

    this.selectedItemHighlightedIndex = null
    this.itemHighlightedIndex = null
    this.focusTextField()
  }

  onClickMenuBtn(forceToggleDropdown: any) {
    forceToggleDropdown()
    if (this.on) this.focusTextField()
    else this.blurTextField()
  }

  onClickClose(evt: any) {
    this.focusTextField()
    this.toggle(evt.value)
  }

  onClickOutside() {
    this.on = false
  }

  onKeydownEsc() {
    if (this.value.length !== 0) {
      this.value = ''
      this.on = true
      this.focusTextField()
      return
    }
    this.on = false
    this.blurTextField()
  }

  onKeydownDeleteTextField() {
    if (this.value !== '') return

    if (this.selectedItemHighlightedIndex === null)
      this.parsedSelectedItemsSync.pop()
    else
      this.parsedSelectedItemsSync = this.parsedSelectedItemsSync.filter(
        (cur, idx) => idx !== this.selectedItemHighlightedIndex,
      )
  }

  onKeydownEnter() {
    if (
      this.itemHighlightedIndex !== null &&
      this.filteredItemsSync[this.itemHighlightedIndex]
    )
      this.toggle(this.filteredItemsSync[this.itemHighlightedIndex])

    if (!this.value) return
    this.blurTextField()

    const found = this.parsedItemsSync.find(
      e => e[this.itemText] === this.value,
    )

    if (found) {
      this.toggle(found)
    } else if (this.allowCreate && this.value.trim().length !== 0) {
      // const length = this.parsedItemsSync.length
      const newItem = {
        [this.itemText]: this.value.trim(),
        [this.itemValue]: this.value.trim(),
      }
      this.parsedItemsSync = [...this.parsedItemsSync, newItem]
      this.parsedSelectedItemsSync = [
        ...this.parsedSelectedItemsSync,
        newItem,
      ]
    }

    setTimeout(() => {
      this.value = ''
      this.focusTextField()
    }, 0)
  }

  moveSelectedItemHighlightIndex(evt: KeyboardEvent) {
    this.itemHighlightedIndex = null

    if (evt.key === 'ArrowRight') {
      if (this.selectedItemHighlightedIndex !== null) {
        ++this.selectedItemHighlightedIndex
      } else {
        this.selectedItemHighlightedIndex = 0
      }
    }

    if (evt.key === 'ArrowLeft')
      this.selectedItemHighlightedIndex !== null
        ? --this.selectedItemHighlightedIndex
        : (this.selectedItemHighlightedIndex =
            this.selectedItemsSync.length - 1)

    if (this.selectedItemHighlightedIndex === null) return

    if (this.selectedItemHighlightedIndex < 0)
      this.selectedItemHighlightedIndex = this.selectedItemsSync.length - 1

    if (this.selectedItemHighlightedIndex >= this.selectedItemsSync.length)
      this.selectedItemHighlightedIndex = 0

    this.$nextTick(() => {
      const highlight = (this.$refs.textField as Vue).$el.querySelector(
        '.hds-highlight',
      )
      if (highlight) {
        highlight.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        })
      }
    })
  }

  moveItemHighlightIndex(evt: KeyboardEvent) {
    this.selectedItemHighlightedIndex = null

    if (evt.key === 'ArrowDown') {
      if (this.itemHighlightedIndex !== null) {
        ++this.itemHighlightedIndex
      } else {
        this.itemHighlightedIndex = 0
      }
    }

    if (evt.key === 'ArrowUp')
      this.itemHighlightedIndex !== null
        ? --this.itemHighlightedIndex
        : (this.itemHighlightedIndex = this.parsedItemsSync.length - 1)

    if (this.itemHighlightedIndex === null) return

    if (this.itemHighlightedIndex < 0)
      this.itemHighlightedIndex = this.parsedItemsSync.length - 1

    if (this.itemHighlightedIndex >= this.parsedItemsSync.length)
      this.itemHighlightedIndex = 0

    this.$nextTick(() => {
      const highlight = (this.$refs.dropdown as Vue).$el.querySelector(
        '.hds-highlight',
      )
      if (highlight) {
        highlight.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    })
  }

  /**
   * 옵션 검색
   */
  @Prop({ type: Boolean, default: false }) allowSearch!: boolean

  /**
   * 다중 선택
   */
  @Prop({ type: Boolean, default: false }) multiple!: boolean

  /**
   * 체크 박스 노출
   */
  @Prop({ type: Boolean, default: false }) checkbox!: boolean

  /**
   * 선택된 아이템 숨김
   */
  @Prop({ type: Boolean, default: false }) hideSelected!: boolean

  /**
   * 칩 클로즈 버튼
   */
  @Prop({ type: Boolean, default: false }) chipClose!: boolean

  /**
   * 드롭다운 높이
   */
  @Prop({ type: String, default: 'auto' }) dropdownHeight!: string

  /**
   * 드롭다운 최대 높이
   */
  @Prop({ type: String, default: 'auto' }) dropdownMaxHeight!: string

  /**
   * 옵션 타이틀
   */
  @Prop({ type: String, default: 'Select an option.' }) placeholder!: string

  /**
   * **커스텀 옵션**: 콤보박스처럼 옵션을 추가
   */
  @Prop({ type: Boolean, default: false }) allowCreate!: boolean

  /**
   * **커스텀 옵션**: 콤보박스처럼 옵션을 수정
   */
  @Prop({ type: Boolean, default: false }) allowUpdate!: boolean

  /**
   * **커스텀 옵션**: 콤보박스처럼 옵션을 삭제
   */
  @Prop({ type: Boolean, default: false }) allowDelete!: boolean

  /**
   * 선택된 옵션을 드래그 앤 드롭으로 정렬 가능
   */
  @Prop({ type: Boolean, default: false }) allowSortSelectedItems!: boolean

  /**
   * 옵션 목록을 드래그 앤 드롭으로 정렬 가능
   */
  @Prop({ type: Boolean, default: false }) allowSortItems!: boolean

  /**
   * Empty text
   */
  @Prop({ type: String, default: 'Empty' }) textEmpty!: string

  /**
   * Create text
   */
  @Prop({ type: String, default: 'Press enter to create' })
  textCreate!: string

  /**
   * Input minimum width
   */
  @Prop({ type: String, default: '10px' }) inputMinWidth!: string

  /**
   * 선택된 아이템이 많아도 한줄로 표시
   */
  @Prop({ type: Boolean, default: false }) singleLine!: boolean

  /**
   * 아이템이 오브젝트 인지.
   */
  @Prop({ type: Boolean, default: false }) itemObject!: boolean

  /**
   * 아이템이 오브젝트일때,
   * 아이템 text 키.
   */
  @Prop({ type: String, default: 'text' }) itemText!: string

  /**
   * 아이템이 오브젝트일때,
   * 아이템 value 키.
   */
  @Prop({ type: String, default: 'value' }) itemValue!: string

  /**
   * 아이템이 오브젝트일때,
   * 아이템의 sub array 키.
   */
  @Prop({ type: String, default: 'array' }) itemArray!: string

  /**
   * limit item text length
   */
  @Prop({ type: Number, default: 0 }) maxLength!: number

  /**
   * hide menu btn
   */
  @Prop({ type: Boolean, default: false }) hideMenuBtn!: boolean

  /**
   * enable clear
   */
  @Prop({ type: Boolean, default: false }) clear!: boolean
}
